import type { TemplateResult } from 'lit';

import {
  DATA_VIEW_BODY_CONTENT_ATTRIBUTE,
  DATA_VIEW_BODY_INTRINSIC_ATTRIBUTE,
  DATA_VIEW_BODY_RENDER_CONTENT_ATTRIBUTE,
  DATA_VIEW_BODY_RENDER_ROOT_ATTRIBUTE,
} from '../../../core/view/data-view-body.js';

export const SETUP_WIZARD_BODY_MIN_HEIGHT = 420;

type SetupWizardBodyContentOptions = {
  configured: boolean;
  renderConfigured: () => TemplateResult;
  renderEmptyState: () => TemplateResult;
  renderSetupWizard: () => TemplateResult;
  wizardOpen: boolean;
};

export function renderSetupWizardBodyContent({
  configured,
  renderConfigured,
  renderEmptyState,
  renderSetupWizard,
  wizardOpen,
}: SetupWizardBodyContentOptions): TemplateResult {
  if (wizardOpen) {
    return renderSetupWizard();
  }
  return configured ? renderConfigured() : renderEmptyState();
}

export function getSetupWizardBodyIntrinsicHeight({
  host,
  visualScale,
}: {
  host: HTMLElement | null | undefined;
  visualScale: number;
}): number {
  if (!host) {
    return 0;
  }
  const scale = visualScale || 1;
  const body = host.querySelector<HTMLElement>(
    `[${DATA_VIEW_BODY_RENDER_CONTENT_ATTRIBUTE}="true"], [${DATA_VIEW_BODY_RENDER_ROOT_ATTRIBUTE}="true"], [${DATA_VIEW_BODY_INTRINSIC_ATTRIBUTE}="true"], [${DATA_VIEW_BODY_CONTENT_ATTRIBUTE}="true"], [role="region"], [role="dialog"]`
  );
  const measuredHeight = body?.getBoundingClientRect().height ?? 0;
  const normalizedHeight = Math.max(
    measuredHeight / scale,
    body?.scrollHeight ?? 0
  );
  if (!Number.isFinite(normalizedHeight) || normalizedHeight <= 0) {
    return SETUP_WIZARD_BODY_MIN_HEIGHT;
  }
  return normalizedHeight;
}
